import CloseIcon from '@mui/icons-material/Close'
import IconButton from '@mui/material/IconButton'
import { SnackbarKey } from 'notistack'

export type MessageKey = SnackbarKey

let notistakEnqueueSnackbar
let notistakCloseSnackbar

export default class Message {
  static registerNotistakEnqueueSnackbar(instance, closeInsatnce) {
    notistakEnqueueSnackbar = instance
    notistakCloseSnackbar = closeInsatnce
  }

  static success(arg) {
    notistakEnqueueSnackbar(arg, { variant: 'success' })
  }

  static custom(text, options) {
    notistakEnqueueSnackbar(text, options)
  }

  static error(arg) {
    notistakEnqueueSnackbar(arg, { variant: 'error' })
  }

  static waiting(text: String, callback: (() => void) | null = null): SnackbarKey {
    return notistakEnqueueSnackbar(text, {
      persist: false,
      content: (id: number, message: string) => {
        return (
          <div
            key={id}
            style={{
              width: '100%',
              background: 'black',
              color: 'white',
              display: 'flex',
              alignItems: 'center',
              paddingRight: '24px',
            }}
          >
            <img src="/images/spinner.svg" alt="spinner" /> {message}
            {callback && (
              <IconButton
                onClick={() => {
                  this.close(id)
                  if (callback) {
                    callback()
                  }
                }}
                style={{ color: '#fff', marginLeft: 'auto' }}
              >
                <CloseIcon />
              </IconButton>
            )}
          </div>
        )
      },
    })
  }

  static closeAll() {
    notistakCloseSnackbar()
  }
  static close(messageKey: MessageKey) {
    notistakCloseSnackbar(messageKey)
  }
}
